import React from 'react';
import Styles from "../Styles.js";

export function ProjectTags(props) {
    return (
    <Styles>
      <h2>Project Info</h2>
      <table className="project-tags" cellSpacing="0" style={{border: "2px solid #000"}}>
          <tbody>
              <tr key="headings">
                  <td className="headings-row">Name</td>
                  <td className="headings-row">Value</td>
              </tr>
              {props.project.tags && props.project.tags.map((tag, idx) =>
                  <tr key={idx}>
                      <td>{tag.name}</td><td>{tag.value}</td>
                  </tr>
              )}
          </tbody>
      </table>
    </Styles>
    );
}
